import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useFavouriteNotice } from "../api/favourite-notice.ts";

/** The toast shown when a star could not be saved (it has been rolled back). */
export function FavouriteNotice() {
  const { t } = useTranslation();
  const notice = useFavouriteNotice();
  if (!notice) return null;
  return (
    <div className="pwa-toast ds-glass ds-text-subheadline" role="alert">
      <TriangleAlert
        aria-hidden="true"
        size={20}
        strokeWidth={1.75}
        className="text-warning shrink-0"
      />
      <span className="flex-1">
        {t(notice === "full" ? "favourites.full" : "favourites.failed")}
      </span>
    </div>
  );
}
